module.exports = __webpack_public_path__ + "img/UserManagement.ae2550ff.svg";